import React from 'react';
import { useActiveClassData, useProfile } from '../state/hooks';
import TeacherTaskRoot from '../TeacherTasks/TeacherTasksRoot';
import StudentTaskRoot from '../StudentTaskRoot';
import NewDocPage from '../NewDocRoot';
import { isNullOrEmpty } from '../../utils/arrays';
import Loader from '../Loader';
import FeedbackProvider from '../GiveFeedback/FeedbackProvider';
import { canAccessSchoolWorkForStudent, canAccessAnyTasks } from '../../utils/userAccessHelper';

const Tasks = ({ role }) => {
  const { data: classData, isLoadingdata: isLoadingclassData } = useActiveClassData();
  const { data: profile } = useProfile();

  if (isLoadingclassData || !profile) {
    return <Loader />;
  }

  const tasks =
    role === 'TEACHER' ? (
      !isNullOrEmpty(classData) ? (
        <TeacherTaskRoot />
      ) : (
        <FeedbackProvider/>
      )
    ) : (canAccessSchoolWorkForStudent(profile) || canAccessAnyTasks(profile)) ? (
      <StudentTaskRoot />
    ) : (
      <NewDocPage />
    );

  return tasks;
};

export default Tasks;
